import React from 'react'
import { Button, Space, Select, Typography } from 'antd'
import { PlusOutlined, ShoppingOutlined, BarChartOutlined } from '@ant-design/icons'
import { theme } from 'antd'
import { hexToRGBA } from '../../../lib/utils'

const { Title } = Typography
const { Option } = Select

const DashboardHeader = ({ showAddModal, showPOModal, timeRange, setTimeRange, dashboardPeriods }) => {
  const { token } = theme.useToken()

  return (
    <div className='dashboard-header inventory-header'>
      <div className='dashboard-header-title'>
        <BarChartOutlined className='dashboard-header-icon' />
        <Title level={4}>Inventory Dashboard</Title>
      </div>
      <Space>
        <Button
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          onClick={showAddModal}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Add Item
        </Button>
        <Button
          icon={<ShoppingOutlined style={{ color: token.colorPrimary }} />}
          onClick={showPOModal}
          style={{
            background: hexToRGBA(token.colorPrimary, 0.1),
            borderColor: token.colorPrimary,
            color: token.colorPrimary,
            fontWeight: 'bold'
          }}
        >
          Create Order
        </Button>
        <Select className='dashboard-filter' defaultValue={timeRange} onChange={setTimeRange} style={{ width: 150 }}>
          {dashboardPeriods.map((period) => (
            <Option key={period.value} value={period.value}>
              {period.label}
            </Option>
          ))}
        </Select>
      </Space>
    </div>
  )
}

export default DashboardHeader
